module.exports = __webpack_public_path__ + "img/Bash.68bbbc94.jpg";